export default __webpack_public_path__ + "static/media/s3.0c2bd388.jpg";